import doRequest from "./doRequest";
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setLogout } from '../store/slices/auth';
import { FORGOT_PASSWORD, RESET_PASSWORD, SIGNUP_INITIATE, SIGNUP_VALIDATE, SIGNUP_COMPLETE } from "../services/URLs";
import { useQueryClient } from '@tanstack/react-query';

export function useRequest() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return async (...args) => {
    try {
      const result = await doRequest(...args);
      return result;
    } catch (error) {
      if (error?.response?.status >= 500) {
        enqueueSnackbar('Unfortunately, we can not process your request at this time. We have been alerted of the issue and will work to resolve it as soon as possible.', { variant: 'warning' });
      }
      if (error?.response?.status === 401 && ![FORGOT_PASSWORD, RESET_PASSWORD, SIGNUP_INITIATE, SIGNUP_VALIDATE, SIGNUP_COMPLETE].includes(error?.response?.config?.url)) {
        // Handle unauthorized access
        dispatch(setLogout());
        queryClient.clear();
        sessionStorage.clear();
        localStorage.clear();
        navigate('/login');
      }
      throw error;
    }
  };
}

export default useRequest;